'use client';

import { usePathname } from 'next/navigation';
import Navbar from '@/components/layout/Navbar';

// Paths where the global header is intentionally omitted.
const HIDDEN_PATHS = [];

export default function NavbarWrapper() {
  const pathname = usePathname();
  if (HIDDEN_PATHS.includes(pathname)) {
    return null;
  }
  return <Navbar />;
}
